"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Logo = exports.SocialIcon = exports.SocialIconsContainer = exports.StyledP = exports.NavLink = exports.LinkList = exports.CallButton = exports.NavigationWrapper = exports.ColumnWrapper = exports.Wrapper = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styledComponentsRtl = _interopRequireDefault(require("styled-components-rtl"));
var _typography = require("@berlitz/globals/lib/components/typography");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var Wrapper = _styledComponents.default.footer.withConfig({
  displayName: "Footerstyle__Wrapper",
  componentId: "sc-1nc5wip-0"
})(["display:flex;align-items:center;flex-direction:column;font-size:", ";line-height:", ";@media (min-width:", "){padding:0 ", ";align-items:flex-start;flex-direction:row;justify-content:space-between;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontSize.xs;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.lineHeight.default;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.lg;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.space.md;
});
exports.Wrapper = Wrapper;
var ColumnWrapper = _styledComponents.default.div.withConfig({
  displayName: "Footerstyle__ColumnWrapper",
  componentId: "sc-1nc5wip-1"
})(["width:100%;min-width:", ";padding-bottom:", ";@media (min-width:", "){max-width:320px;", "}@media (min-width:", "){width:100%;@supports (display:flex){flex:1 1 100%;}}@media (min-width:", "){width:50%;padding-bottom:", ";", " @supports (display:flex){flex:1 1 50%;}}@media (min-width:", "){justify-content:space-between;", " max-width:240px;@supports (display:flex){flex:1;width:auto;}@supports (max-width:max-content){max-width:max-content;}&:last-child{", "}}"], function (_ref5) {
  var fixed = _ref5.fixed;
  return fixed ? '240px' : 'auto';
}, function (_ref6) {
  var paddingBottom = _ref6.paddingBottom,
    theme = _ref6.theme;
  return paddingBottom ? theme.space.lg : 'unset';
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.breakpoints.sm;
}, (0, _styledComponentsRtl.default)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      padding-right: ", ";\n    "])), function (_ref8) {
  var theme = _ref8.theme;
  return theme.space.sm;
}), function (_ref9) {
  var theme = _ref9.theme;
  return theme.breakpoints.md;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.breakpoints.lg;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.space.lg;
}, (0, _styledComponentsRtl.default)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      padding-right: ", ";\n    "])), function (_ref12) {
  var theme = _ref12.theme;
  return theme.space.md;
}), function (_ref13) {
  var theme = _ref13.theme;
  return theme.breakpoints.xl;
}, (0, _styledComponentsRtl.default)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      padding-right: ", ";\n    "])), function (_ref14) {
  var theme = _ref14.theme;
  return theme.space.xl;
}), (0, _styledComponentsRtl.default)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n        padding-right: 0;\n      "]))));
exports.ColumnWrapper = ColumnWrapper;
var NavigationWrapper = _styledComponents.default.div.withConfig({
  displayName: "Footerstyle__NavigationWrapper",
  componentId: "sc-1nc5wip-2"
})(["width:100%;display:flex;flex-direction:column;align-items:center;@media (min-width:", "){flex-direction:row;flex-wrap:wrap;align-items:flex-start;", " justify-content:space-between;}@media (min-width:", "){flex-wrap:unset;", " justify-content:space-around;}"], function (_ref15) {
  var theme = _ref15.theme;
  return theme.breakpoints.lg;
}, (0, _styledComponentsRtl.default)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n      padding-left: ", ";\n    "])), function (_ref16) {
  var theme = _ref16.theme;
  return theme.space.xl;
}), function (_ref17) {
  var theme = _ref17.theme;
  return theme.breakpoints.xl;
}, (0, _styledComponentsRtl.default)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n      padding-left: 0;\n    "]))));
exports.NavigationWrapper = NavigationWrapper;
var CallButton = _styledComponents.default.div.withConfig({
  displayName: "Footerstyle__CallButton",
  componentId: "sc-1nc5wip-3"
})(["align-items:center;color:", ";font-weight:", ";font-size:", ";margin-top:", ";padding:0;text-decoration:none;text-align:center;@media (min-width:", "){", "}"], function (_ref18) {
  var theme = _ref18.theme;
  return theme.colors.text01;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.fontWeight.bold;
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.fontSize.xxs;
}, function (_ref21) {
  var theme = _ref21.theme;
  return theme.space.md;
}, function (_ref22) {
  var theme = _ref22.theme;
  return theme.breakpoints.lg;
}, (0, _styledComponentsRtl.default)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n      text-align: left;\n    "]))));
exports.CallButton = CallButton;
var LinkList = _styledComponents.default.ul.withConfig({
  displayName: "Footerstyle__LinkList",
  componentId: "sc-1nc5wip-4"
})(["padding-bottom:", ";@media (min-width:", "){padding:0;}"], function (_ref23) {
  var theme = _ref23.theme;
  return theme.space.sm;
}, function (_ref24) {
  var theme = _ref24.theme;
  return theme.breakpoints.lg;
});
exports.LinkList = LinkList;
var NavLink = _styledComponents.default.li.withConfig({
  displayName: "Footerstyle__NavLink",
  componentId: "sc-1nc5wip-5"
})(["display:flex;font-size:", ";line-height:", ";a,button{width:100%;color:", ";text-decoration:none;padding:", " 0;transition:", ";@media (min-width:", "){padding:0;margin-top:", ";}&:hover,&:active{color:", ";}}button{display:flex;cursor:pointer;width:100%;}"], function (_ref25) {
  var theme = _ref25.theme;
  return theme.fontSize.xxs;
}, function (_ref26) {
  var theme = _ref26.theme;
  return theme.lineHeight.md;
}, function (_ref27) {
  var theme = _ref27.theme;
  return theme.colors.text01;
}, function (_ref28) {
  var theme = _ref28.theme;
  return "".concat(theme.space.xs);
}, function (_ref29) {
  var theme = _ref29.theme;
  return theme.animation.transitionMedium;
}, function (_ref30) {
  var theme = _ref30.theme;
  return theme.breakpoints.lg;
}, function (_ref31) {
  var theme = _ref31.theme;
  return theme.space.xs;
}, function (_ref32) {
  var theme = _ref32.theme;
  return theme.colors.brandPrimary;
});
exports.NavLink = NavLink;
var StyledP = (0, _styledComponents.default)(_typography.P).withConfig({
  displayName: "Footerstyle__StyledP",
  componentId: "sc-1nc5wip-6"
})(["font-weight:", ";"], function (_ref33) {
  var theme = _ref33.theme;
  return theme.fontWeight.bold;
});
exports.StyledP = StyledP;
var SocialIconsContainer = _styledComponents.default.div.withConfig({
  displayName: "Footerstyle__SocialIconsContainer",
  componentId: "sc-1nc5wip-7"
})(["margin:", " 0;display:flex;justify-content:center;@media (min-width:", "){margin-top:", ";justify-content:flex-start;}"], function (_ref34) {
  var theme = _ref34.theme;
  return theme.space.lg;
}, function (_ref35) {
  var theme = _ref35.theme;
  return theme.breakpoints.lg;
}, function (_ref36) {
  var theme = _ref36.theme;
  return theme.space.xl;
});
exports.SocialIconsContainer = SocialIconsContainer;
var SocialIcon = _styledComponents.default.a.withConfig({
  displayName: "Footerstyle__SocialIcon",
  componentId: "sc-1nc5wip-8"
})(["transition:", ";margin:0 ", ";@media (min-width:", "){margin:0 ", " 0 0;&:last-child{margin-right:0;}}"], function (_ref37) {
  var theme = _ref37.theme;
  return theme.animation.transitionMedium;
}, function (_ref38) {
  var theme = _ref38.theme;
  return theme.space.xs;
}, function (_ref39) {
  var theme = _ref39.theme;
  return theme.breakpoints.lg;
}, function (_ref40) {
  var theme = _ref40.theme;
  return theme.space.sm;
});
exports.SocialIcon = SocialIcon;
var Logo = _styledComponents.default.div.withConfig({
  displayName: "Footerstyle__Logo",
  componentId: "sc-1nc5wip-9"
})(["text-align:center;@media (min-width:", "){", "}"], function (_ref41) {
  var theme = _ref41.theme;
  return theme.breakpoints.lg;
}, (0, _styledComponentsRtl.default)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n      text-align: left;\n    "]))));
exports.Logo = Logo;